import { createAction, props } from '@ngrx/store';

export const getMinistryServiceRegSummary = createAction(
  '[ServiceRegSummary/API] Get Ministry Vs Services'
);

export const upsertMinistryServiceRegSummary = createAction(
  '[ServiceRegSummary/API] Upsert Ministry Vs Services',
  props<{ rows: any[] }>()
);

export const clearMinistryServiceRegSummary = createAction(
  '[ServiceRegSummary/API] Clear Ministry Vs Services'
);

export const getSectorServiceRegSummary = createAction(
  '[ServiceRegSummary/API] Get Sector Vs Services'
);

export const upsertSectorServiceRegSummary = createAction(
  '[ServiceRegSummary/API] Upsert Sector Vs Services',
  props<{ rows: any[] }>()
);

export const clearSectorServiceRegSummary = createAction(
  '[ServiceRegSummary/API] Clear Sector Vs Services'
);
